import { render } from "./UserScore.vue?vue&type=template&id=57a8daf2&scoped=true"
import script from "./UserScore.vue?vue&type=script&lang=js"
export * from "./UserScore.vue?vue&type=script&lang=js"

import "./UserScore.vue?vue&type=style&index=0&id=57a8daf2&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a8daf2"]])

export default __exports__